import { useTimeout as useMantineTimeout } from '@mantine/hooks';

export const useTimeout = useMantineTimeout;
